import React from "react";
import { useHistory } from "react-router-dom";

import styles from "./styles";
import { IMAGES } from "../../../configs";
import { Button, Input } from "../../../components";
import {
  Container,
  DescImage,
  DescText,
  WrapButton,
  WrapForm
} from "../components";

interface Props {
  next: string;
}

const EmailRegister = ({ next }: Props) => {
  const history = useHistory();

  return (
    <Container>
      <DescImage image={IMAGES.iconBuilding} />
      <DescText
        title="Your Company"
        desc="Enter your name,company name and your company"
      />
      <WrapForm>
        <Input style={styles.input} placeholder="Full name" />
        <Input style={styles.input} placeholder="Company Name" />
        <Input style={styles.input} placeholder="Position" />
        <WrapButton>
          <Button title="CONTINUE" onPress={() => history.push(next)} />
        </WrapButton>
      </WrapForm>
    </Container>
  );
};

export default EmailRegister;
